export const SET_OPTIONS = 'SET_OPTIONS'
export const SET_LOADING = 'SET_LOADING'
export const SET_VALUE = 'SET_VALUE'
export const SET_ERROR = 'SET_ERROR'
export const ADD = 'ADD_TYPEAHEAD'
export const REMOVE = 'REMOVE_TYPEAHEAD'